import { Component, OnInit } from '@angular/core';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';

@Component({
  selector: 'app-job-footer',
  templateUrl: './job-footer.component.html',
  styleUrls: ['./job-footer.component.scss']
})
export class JobFooterComponent implements OnInit {
  
  public ourCompanyName: string=this.platformInviewService.getOurCompanyName();
  public year          : number=new Date().getFullYear();

  constructor(
    private platformInviewService: PlatformInviewService
  ) { }

  ngOnInit(): void { }
}
